import { render, staticRenderFns } from "./salesforce-settings-authenticate.vue?vue&type=template&id=07390851"
import script from "./salesforce-settings-authenticate.vue?vue&type=script&lang=js"
export * from "./salesforce-settings-authenticate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports